<mat-form-field
  [appearance]="appearance ? appearance : 'fill'"
  [floatLabel]="floatLabel ? floatLabel : 'auto'"
  >
  <mat-label>{{ locationsLoaded ? label : 'Loading...' }}</mat-label>
  <mat-chip-grid #chipList aria-label="Location">
    @for (selectedLocation of selectedLocations; track selectedLocation) {
      <mat-chip-row
        [editable]="selectable"
        [removable]="removable"
        (removed)="removeLocation(selectedLocation)"
        >
        {{ selectedLocation.tag }} - {{ selectedLocation.name }}
        @if (removable) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input
      #locationInput
      aria-label="Location"
      [attr.data-testid]="'location_input'"
      [formControl]="input"
      matInput
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      [placeholder]="locationsLoaded ? (selectedLocations.length == 0 ? 'Type location name or number' : '') : 'Loading locations...'"
      [readonly]="!locationsLoaded"
      />
  </mat-chip-grid>
  <mat-autocomplete
    #auto="matAutocomplete"
    [displayWith]="display"
    (optionSelected)="optionSelected($event)"
    >
    @for (filteredLocation of filteredLocations; track filteredLocation) {
      <mat-option
        [attr.data-testid]="filteredLocation.name + '_option'"
        [value]="filteredLocation"
        >
        {{ filteredLocation.tag }} - {{ filteredLocation.name }}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>
@if (tagExists) {
  <div class="mat-error">{{ errorMessage }}</div>
}
